import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { exchangeSignatureV2Invitation } from '@/api/signatureV2.api';
import { Button } from '@/components/UI/Button';
import { Card, Header, Notice, Page, PublicContent } from './styles';
import { getSignatureV2ApiError } from './workflowState';

export default function SignatureV2InvitationPage() {
  // @ts-ignore i18next's deeply nested translation key type exceeds CRA's incremental compiler limit.
  const { t } = useTranslation();
  const { token = '' } = useParams();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const continueToSigning = async () => {
    setBusy(true);
    setError('');
    try {
      const ticket = await exchangeSignatureV2Invitation(token);
      window.location.assign(ticket.entry_url);
    } catch (reason) {
      const failure = getSignatureV2ApiError(reason);
      const translate = t as unknown as (key: string, options?: Record<string, unknown>) => string;
      setError(failure.code
        ? translate(`signatureV2.errors.${failure.code}`, { defaultValue: failure.message || translate('signatureV2.invitation.invalid') })
        : failure.message || t('signatureV2.invitation.invalid'));
      setBusy(false);
    }
  };

  return (
    <Page>
      <PublicContent>
        <Header>
          <div>
            <h1>{t('signatureV2.invitation.title')}</h1>
            <p>{t('signatureV2.invitation.subtitle')}</p>
          </div>
        </Header>
        <Card>
          {error && <Notice danger role="alert">{error}</Notice>}
          <p>{t('signatureV2.invitation.notice')}</p>
          <Button type="button" variant="primary" disabled={busy || !token} onClick={continueToSigning}>
            {busy ? t('signatureV2.invitation.opening') : t('signatureV2.invitation.continue')}
          </Button>
        </Card>
      </PublicContent>
    </Page>
  );
}
